module.exports = __webpack_public_path__ + "img/處女座.56521dcb.svg";